import React from 'react'
import { ThemeProvider as MuiThemeProvider, StyledEngineProvider } from '@mui/material/styles'
import { getLightE3dcTheme, getLightFlowTheme } from '../../../../theme'

interface Props {
  children: React.ReactNode
}

const ThemeProvider: React.FC<Props> = ({ children }) => {
  const theme = process.env.REACT_APP_THEME === 'e3dc' ? getLightE3dcTheme() : getLightFlowTheme()
  return (
    <StyledEngineProvider injectFirst>
      <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>
    </StyledEngineProvider>
  )
}

export default ThemeProvider
